import{withNaming}from"@bem-react/classname";export const cn=withNaming({n:"cgr--",e:"-",m:"_"});
//# sourceMappingURL=bem.js.map